import React, {useState} from 'react'
import { formContent } from "./content"
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import Button from "../../../../Components/Form/Button/Button";
import { useForm, FormProvider } from "react-hook-form";
import BusinessDetailsApi from "../../../../Api/BusinessDetailsApi";
import { getBusinessDetailsCookie, getResponseError, getUserDetailsCookie, setBusinessDetailsCookie} from "../../../../Api/Utils/apiUtils";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import RadioGroup from "../../../../Components/Form/RadioGroup/RadioGroup";
import ManageBusinessMap from '../../../../Components/Accounts/ManageBusinessMap/ManageBusinessMap';
import RadiusRange from '../../../../Components/Accounts/Radius/RadiusRange';
import MultiCheckbox from '../../../../Components/Accounts/MultiCheckbox/MultiCheckbox';

const BusinessComponent = () => {
    const {
        heading,
        coverageType,
        category,
        saveButton
    } = formContent;

    const [errorMessage, setErrorMessage] = useState(null);
    const [states, setStates] = useState([]);
    const [businessCategories, setBusinessCategories] = useState([]);
    const [selectedCategory, setselectedCategory] = useState([])
    const [businessId, setBusinessId] = useState(null)
    const [lat, setlat] = useState(null)
    const [lng, setlng] = useState(null)
    const [radius, setRadius] = useState()
    const [selectedstate, setSelecetedState] = useState([])

    function errorTimeOut(){
        setTimeout(() => {
            setErrorMessage(null)
        }, 5000);
    }

    React.useEffect(() => {
        const getCategoryKeywordList = async () => {
            const response = await BusinessDetailsApi.getCategoryKeywordList();
            const apiError = getResponseError(response);
            if(apiError){
                setErrorMessage(apiError);
                errorTimeOut()
            } else {
                const keywordList = response.objectVal;
                const {businessCoverageInfo, businessCategoryInfo} = keywordList;
                const stateList = [];
                businessCoverageInfo.forEach(state => {
                    state.value = state.id;
                    state.label = state.title;
                    stateList.push(state);
                });
                setStates(stateList);

                const categoryList = [];
                businessCategoryInfo.forEach(cat => {
                    cat.value = cat.id;
                    cat.label = cat.title;
                    categoryList.push(cat);
                });
                setBusinessCategories(categoryList);
            }
        };
        const loadBusinessDetails = async () => {
            const user = getUserDetailsCookie()
            const businessDetailsResponse = await BusinessDetailsApi.getBusinessDetails(user.id)
            const businessDetailsApiError = getResponseError(businessDetailsResponse)
            if (businessDetailsApiError) {
                setErrorMessage(businessDetailsApiError)
                errorTimeOut()
            }else{
                const businessinfo = businessDetailsResponse.objectVal
                setBusinessDetailsCookie(businessinfo)
                setBusinessId(businessinfo.id)
                setRadius(parseInt(businessinfo.radius))
                const statedata = businessinfo.coverageArea.split(",")
                setSelecetedState(statedata)
                const categorydata = businessinfo.category.split(",")
                setselectedCategory(categorydata)
            }
        }
        function getTheLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    setlat(position.coords.latitude)
                    setlng(position.coords.longitude)
                })
    
            }
        }
        getTheLocation()
        loadBusinessDetails()
        getCategoryKeywordList();
    }, []);

    const bussiness = getBusinessDetailsCookie()

    const formBinding = useForm({
        defaultValues: bussiness
    });
    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));

    const submitForm = async (data) => {
        data.busiId = businessId
        data.radius = radius
        data.businessLatitude = `${lat}`
        data.businessLongitude = `${lng}`
        let modifiedArray = ""
        for (let j = 0; j < selectedstate.length; j++) {
            if (selectedstate.length === j+1) {
                modifiedArray = `${modifiedArray+selectedstate[j]}`
            }else{
                modifiedArray = `${modifiedArray+selectedstate[j]},`
            }
        }
        data.coverageArea = modifiedArray
        modifiedArray = ""

        for (let j = 0; j < selectedCategory.length; j++) {
            if (selectedCategory.length === j+1) {
                modifiedArray = `${modifiedArray+selectedCategory[j]}`
            }else{
                modifiedArray = `${modifiedArray+selectedCategory[j]},`
            }
        }
        data.category = modifiedArray
        modifiedArray = ""
        const response = await BusinessDetailsApi.updateBusinessService(data)
        const responseApiError = getResponseError(response)
        if (responseApiError) {
            setErrorMessage(responseApiError)
        }else{
            window.location.reload()
        }
    }
    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <FormProvider {...formBinding}>
                    <form id="business-form" onSubmit={handleSubmit(submitForm)}>
                        <RadioGroup {...coverageType}/>
                        <MultiCheckbox selectedstate={selectedstate} label={coverageType.label} Items={states} setSelecetedState={setSelecetedState} />
                        <RadiusRange radius={radius} setRadius={setRadius} />
                        <ManageBusinessMap lat={lat && lat} lng={lng && lng} size={radius} />
                        <MultiCheckbox checkboxstyle={{marginTop:"16px"}} selectedstate={selectedCategory} label={category.label} Items={businessCategories} setSelecetedState={setselectedCategory} />
                        <Button {...saveButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default BusinessComponent
